/* eslint-disable no-use-before-define */
import React from 'react'
import { $ } from '../twd';

export default React.forwardRef(({value='', ...props}={}, ref) =>
    <div className="form-icon-group icon-left">
    <i className="material-icons" aria-hidden="true">event</i>
    <input type="text" className="form-control"
        ref={ref}
        value={value}
        onChange={() => {}}
        onClick={(e) => {onClick(e, props)}}
        />
    </div>)

const onClick = (e, {onChange, ...props}) => {
    let el = $(e.target)
    if (el.data('datepicker')) return
    e.preventDefault()

    el.datepicker({autoclose:true, ...props})

    if (onChange) {
        el.on('changeDate', () => {
            let a = el.datepicker('getFormattedDate')
            onChange({target:{value:a}})
        })
    }

    el.datepicker('show')
}


// WEBPACK FOOTER //
// ./src/twd/fields/date.js